import { useEffect, useRef } from "react";
import {
  Info,
  InfoModal,
} from "./styles";
import InfoIcon from "../../assets/i_icon.svg";

const InfoComponent = ({ show, handleOnOpen, handleOnClose }: { show: boolean, handleOnOpen: () => void, handleOnClose: () => void }) => {
  const modalRef = useRef<HTMLDivElement>(null);

  const handleOutsideClick = (e: any) => {
    if (modalRef.current) {
      if (modalRef.current.contains(e.target)) {
        handleOnClose()
        document.body.style.removeProperty('overflow');
      }
    }
  };

  useEffect(() => {
    if (show) {
      document.addEventListener("click", handleOutsideClick);
    }
    return () => {
      document.removeEventListener("click", handleOutsideClick);
    };
  }, [handleOutsideClick]);

  return (
    <div>
      <Info onClick={() => {
        document.body.style.overflow = "hidden";
        handleOnOpen()
      }}>
        <img src={InfoIcon} alt="i icon" />
      </Info>
      {
        show && (
          <InfoModal ref={modalRef} />
        )
      }
    </div >
  )
};

export default InfoComponent;
